const firebaseConfig = {
    apiKey: "AIzaSyALzgObNJZlY-pL50jc7c9wh0DWj63W_oc",
    authDomain: "ema-jhon-simple-auth.firebaseapp.com",
    databaseURL: "https://ema-jhon-simple-auth.firebaseio.com",
    projectId: "ema-jhon-simple-auth",
    storageBucket: "ema-jhon-simple-auth.appspot.com",
    messagingSenderId: "811515584994",
    appId: "1:811515584994:web:9ab5e1b3e06e9ef19c59bb"
};
export default firebaseConfig;